'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoTag = function GoTag(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5h-10l-5 5v10l20 20 15-15-20-20z m-12.5 13.8v-7.5l3.8-3.8h7.5l17.5 17.5-11.3 11.3-17.5-17.5z m15-3.8l-7.5 7.5 10 10 7.5-7.5-10-10z m-3.7 7.5l3.7-3.7 6.3 6.2-3.8 3.8-6.2-6.3z m-1.3-8.7c0-2.1-1.7-3.8-3.7-3.8s-3.8 1.7-3.8 3.8 1.7 3.7 3.8 3.7 3.7-1.7 3.7-3.7z m-3.7 1.2c-0.7 0-1.3-0.6-1.3-1.2s0.6-1.3 1.3-1.3 1.2 0.6 1.2 1.3-0.6 1.2-1.2 1.2z' })
        )
    );
};

exports.default = GoTag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/tag.js
// module id = 1998
// module chunks = 0